// src/hooks/useAuth.jsx

import { createContext, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage";
import axios from "axios";
import { RootActions } from "store/slices/rootSlice";
import { useAppDispatch } from "hooks/useRedux";
import useMixpanel from "hooks/useMixpanel";
import { resetBusinessState } from "store/slices/businessSlice";
const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [user, setUser, deleteUser] = useLocalStorage("user", null);
  const [token, setToken, deletToken] = useLocalStorage("token", null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { trackEvent } = useMixpanel();

  // call this function when you want to authenticate the user
  const login = async (data: any, navigationUrl: string = "/") => {
    setToken(data?.data?.access);
    setUser(data?.data);
    if (!!data?.data?.access) {
      axios.defaults.headers.common.Authorization = `Bearer ${data?.data?.access}`;
      navigate(navigationUrl);
    }
  };

  // call this function to sign out logged in user
  const logout = () => {
    if (token) {
      delete axios.defaults.headers.common.Authorization;
      navigate("/");
    }
    dispatch(resetBusinessState());
    dispatch({ type: RootActions.RESET_STORE });
    deleteUser();
    deletToken();
    localStorage.clear();
    navigate("/", { replace: true });
    trackEvent("signout_success");
  };

  const value: AuthContextType = useMemo(
    () => ({
      user,
      login,
      logout,
    }),
    [user]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
